import { render, staticRenderFns } from "./NotificationCompanyBecomeDeputy.vue?vue&type=template&id=7f46ba7a&scoped=true&lang=pug&"
import script from "./NotificationCompanyBecomeDeputy.vue?vue&type=script&lang=js&"
export * from "./NotificationCompanyBecomeDeputy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f46ba7a",
  null
  
)

export default component.exports